module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mr-440d1a2f2c0dc582804262036d1cb44e.svg";